//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from '@/services/CommonServices'
import * as OM from '@/Model'
import { baseUrl } from '@/config'
import { useRouter, type Router } from 'vue-router'
import { type ResponseType } from 'axios'

class _AcademyContentClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfAcademyContent> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfAcademyContent>(baseUrl + 'api/AcademyContent/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(createAcademyVM : OM.CreateAcademyVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/AcademyContent/Create', createAcademyVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  edit(editAcademyVM : OM.EditAcademyVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AcademyContent/Edit', editAcademyVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  


  

  updateImage(identifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/AcademyContent/UpdateImage?identifier=' + identifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addAvailableFor(editAvailableForVM : OM.EditAvailableForVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AcademyContent/AddAvailableFor', editAvailableForVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  removeAvailableFor(editAvailableForVM : OM.EditAvailableForVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AcademyContent/RemoveAvailableFor', editAvailableForVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  


  

  updateAttachment(identifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/AcademyContent/UpdateAttachment?identifier=' + identifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getCompanyUsageCount(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<number> {
  
    return CommonServices.defaultGet<number>(baseUrl + 'api/AcademyContent/GetCompanyUsageCount', { identifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

  

  
  
  
  

  

  delete(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AcademyContent/Delete?identifier=' + identifier, { }, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getQuestionCount(contentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.QuestionCountVM> {
  
    return CommonServices.defaultGet<OM.QuestionCountVM>(baseUrl + 'api/AcademyContent/GetQuestionCount', { contentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAdminQuestions(contentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AdminQuestionListVM[]> {
  
    return CommonServices.defaultGet<OM.AdminQuestionListVM[]>(baseUrl + 'api/AcademyContent/GetAdminQuestions', { contentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  replyToQuestion(replyVM : OM.ReplyToQuestionVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AcademyContent/ReplyToQuestion', replyVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAppUserAcademyDetail(academyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserAcademyDetailVM> {
  
    return CommonServices.defaultGet<OM.AppUserAcademyDetailVM>(baseUrl + 'api/AcademyContent/GetAppUserAcademyDetail', { academyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getComments(contentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserCommentListVM[]> {
  
    return CommonServices.defaultGet<OM.AppUserCommentListVM[]>(baseUrl + 'api/AcademyContent/GetComments', { contentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addView(contentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AcademyContent/AddView', { contentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getUserVote(contentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<number> {
  
    return CommonServices.defaultGet<number>(baseUrl + 'api/AcademyContent/GetUserVote', { contentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createVote(createVoteVM : OM.CreateVoteVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AcademyContent/CreateVote', createVoteVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createComment(createCommentVM : OM.CreateCommentVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AcademyContent/CreateComment', createCommentVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAppUserAcademyList(categoryIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserAcademyListVM[]> {
  
    return CommonServices.defaultGet<OM.AppUserAcademyListVM[]>(baseUrl + 'api/AcademyContent/GetAppUserAcademyList', { categoryIdentifier }, showSpinner, responseType)
  }
}
export let AcademyContentClient = new _AcademyContentClient();

class _AppNotificationClient {

  

  

  


  

  
  
  
  

  

  getMyNotifications(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppNotification[]> {
  
    return CommonServices.defaultGet<OM.AppNotification[]>(baseUrl + 'api/AppNotification/GetMyNotifications', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getUnreadCount(showSpinner = true, responseType: ResponseType = 'json') : Promise<number> {
  
    return CommonServices.defaultGet<number>(baseUrl + 'api/AppNotification/GetUnreadCount', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  setRead(notificationIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppNotification/SetRead', { notificationIdentifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  setAllRead(showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppNotification/SetAllRead', {  }, showSpinner, responseType)
  }
}
export let AppNotificationClient = new _AppNotificationClient();

class _BoughtPackageClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  




  

  getAllByCompanyPaged(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBoughtPackage> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBoughtPackage>(baseUrl + 'api/BoughtPackage/GetAllByCompanyPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMine(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BoughtPackage[]> {
  
    return CommonServices.defaultGet<OM.BoughtPackage[]>(baseUrl + 'api/BoughtPackage/GetMine', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getRemainingPackagesByUser(userIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.RemainingPackagesByCategoryVM[]> {
  
    return CommonServices.defaultGet<OM.RemainingPackagesByCategoryVM[]>(baseUrl + 'api/BoughtPackage/GetRemainingPackagesByUser', { userIdentifier }, showSpinner, responseType)
  }
}
export let BoughtPackageClient = new _BoughtPackageClient();

class _BuyablePackageClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBuyablePackage> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBuyablePackage>(baseUrl + 'api/BuyablePackage/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(createBuyablePackageVM : OM.CreateBuyablePackageVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/BuyablePackage/Create', createBuyablePackageVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  update(updateBuyablePackageVM : OM.UpdateBuyablePackageVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/BuyablePackage/Update', updateBuyablePackageVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  enable(buyablePackageIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BuyablePackage/Enable', { buyablePackageIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  disable(buyablePackageIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BuyablePackage/Disable', { buyablePackageIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getPackagesByCategory(categoryIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserBuyablePackageListVM[]> {
  
    return CommonServices.defaultGet<OM.AppUserBuyablePackageListVM[]>(baseUrl + 'api/BuyablePackage/GetPackagesByCategory', { categoryIdentifier }, showSpinner, responseType)
  }
}
export let BuyablePackageClient = new _BuyablePackageClient();

class _CategoryClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfCategoryListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfCategoryListVM>(baseUrl + 'api/Category/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllAsTextIdentifier(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/Category/GetAllAsTextIdentifier', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getByID(categoryIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.Category> {
  
    return CommonServices.defaultGet<OM.Category>(baseUrl + 'api/Category/GetByID', { categoryIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(createCategoryVM : OM.CreateCategoryVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Category/Create', createCategoryVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  edit(editCategoryVM : OM.EditCategoryVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Category/Edit', editCategoryVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  


  

  updateVideo(identifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Category/UpdateVideo?identifier=' + identifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  


  

  updateImage(identifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Category/UpdateImage?identifier=' + identifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }
}
export let CategoryClient = new _CategoryClient();

class _ChatClient {

  

  

  


  

  
  
  
  

  

  getRooms(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.ChatRoom[]> {
  
    return CommonServices.defaultGet<OM.ChatRoom[]>(baseUrl + 'api/Chat/GetRooms', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getRoom(prenotazioneId : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.ChatRoom> {
  
    return CommonServices.defaultGet<OM.ChatRoom>(baseUrl + 'api/Chat/GetRoom', { prenotazioneId }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getMessages(roomId : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.ChatMessage[]> {
  
    return CommonServices.defaultGet<OM.ChatMessage[]>(baseUrl + 'api/Chat/GetMessages', { roomId }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  

  

  sendMessage(roomId : string, request : OM.SendMessageRequest, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Chat/SendMessage?roomId=' + roomId, request, { }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getUnreadCount(showSpinner = true, responseType: ResponseType = 'json') : Promise<number> {
  
    return CommonServices.defaultGet<number>(baseUrl + 'api/Chat/GetUnreadCount', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

  

  
  
  
  

  

  markRoomAsRead(roomId : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Chat/MarkRoomAsRead?roomId=' + roomId, { }, { }, showSpinner, responseType)
  }
}
export let ChatClient = new _ChatClient();

class _CompanyClient {

  

  

  


  

  
  
  
  

  

  getAllAsTextIdentifier(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/Company/GetAllAsTextIdentifier', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllTimezone(showSpinner = true, responseType: ResponseType = 'json') : Promise<{ [key: string]: OM.CustomTimezoneInfo; }> {
  
    return CommonServices.defaultGet<{ [key: string]: OM.CustomTimezoneInfo; }>(baseUrl + 'api/Company/GetAllTimezone', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getCompanyBookingsStats(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.CompanyBookingsStatsVM> {
  
    return CommonServices.defaultGet<OM.CompanyBookingsStatsVM>(baseUrl + 'api/Company/GetCompanyBookingsStats', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getDetail(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.CompanyDetailVM> {
  
    return CommonServices.defaultGet<OM.CompanyDetailVM>(baseUrl + 'api/Company/GetDetail', { identifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getStatsByCompanyId(companyId : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.CompanyStatsVM> {
  
    return CommonServices.defaultGet<OM.CompanyStatsVM>(baseUrl + 'api/Company/GetStatsByCompanyId', { companyId }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfCompanyListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfCompanyListVM>(baseUrl + 'api/Company/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(createCompanyVM : OM.CreateCompanyVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Company/Create', createCompanyVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  editName(editCompanyVM : OM.EditCompanyVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Company/EditName', editCompanyVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  changeCompanyCode(editCompanyCodeVM : OM.EditCompanyCodeVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Company/ChangeCompanyCode', editCompanyCodeVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  


  

  updateImage(identifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Company/UpdateImage?identifier=' + identifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  enable(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/Company/Enable', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  disable(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/Company/Disable', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getRegistrationFormByID(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseField[]> {
  
    return CommonServices.defaultGet<OM.BaseField[]>(baseUrl + 'api/Company/GetRegistrationFormByID', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getRegistrationFormByCode(companyCode : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseField[]> {
  
    return CommonServices.defaultGet<OM.BaseField[]>(baseUrl + 'api/Company/GetRegistrationFormByCode', { companyCode }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getByCompanyCode(companyCode : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserCompanyDetailVM> {
  
    return CommonServices.defaultGet<OM.AppUserCompanyDetailVM>(baseUrl + 'api/Company/GetByCompanyCode', { companyCode }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getCanBuyPackages(showSpinner = true, responseType: ResponseType = 'json') : Promise<boolean> {
  
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/Company/GetCanBuyPackages', {  }, showSpinner, responseType)
  }
}
export let CompanyClient = new _CompanyClient();

class _ConsulenteCategoryClient {

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAllByConsulenteIdentifier(consulenteIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.ConsulenteCategoryDetailVM[]> {
  
    return CommonServices.defaultGet<OM.ConsulenteCategoryDetailVM[]>(baseUrl + 'api/ConsulenteCategory/GetAllByConsulenteIdentifier', { consulenteIdentifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMine(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.MyConsulenteCategoryVM[]> {
  
    return CommonServices.defaultGet<OM.MyConsulenteCategoryVM[]>(baseUrl + 'api/ConsulenteCategory/GetMine', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllConsulentiByCategory(showSpinner = true, responseType: ResponseType = 'json') : Promise<{ [key: string]: OM.TextIdentifier[]; }> {
  
    return CommonServices.defaultGet<{ [key: string]: OM.TextIdentifier[]; }>(baseUrl + 'api/ConsulenteCategory/GetAllConsulentiByCategory', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  

  

  delete(consulenteIdentifier : string, categoryIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/ConsulenteCategory/Delete', { consulenteIdentifier, categoryIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(consulenteCategoryCreateVM : OM.ConsulenteCategoryCreateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/ConsulenteCategory/Create', consulenteCategoryCreateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateInformation(consulenteCategoryUpdateInformationVM : OM.ConsulenteCategoryUpdateInformationVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/ConsulenteCategory/UpdateInformation', consulenteCategoryUpdateInformationVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  editBusinessHoursSchedule(consulenteCategoryBusinessHoursScheduleEditVM : OM.ConsulenteCategoryBusinessHoursScheduleEditVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/ConsulenteCategory/EditBusinessHoursSchedule', consulenteCategoryBusinessHoursScheduleEditVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  removeBusinessHoursSchedule(consulenteCategoryBusinessHoursScheduleRemoveVM : OM.ConsulenteCategoryBusinessHoursScheduleRemoveVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/ConsulenteCategory/RemoveBusinessHoursSchedule', consulenteCategoryBusinessHoursScheduleRemoveVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addBusinessHoursSchedule(consulenteCategoryBusinessHoursScheduleAddVM : OM.ConsulenteCategoryBusinessHoursScheduleAddVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/ConsulenteCategory/AddBusinessHoursSchedule', consulenteCategoryBusinessHoursScheduleAddVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  makeDefaultBusinessHoursSchedule(consulenteCategoryBusinessHoursScheduleMakeDefaultVM : OM.ConsulenteCategoryBusinessHoursScheduleMakeDefaultVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/ConsulenteCategory/MakeDefaultBusinessHoursSchedule', consulenteCategoryBusinessHoursScheduleMakeDefaultVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  overrideDefaultBusinessHoursSchedule(consulenteCategoryBusinessHoursScheduleMakeDefaultVM : OM.ConsulenteCategoryBusinessHoursScheduleMakeDefaultVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.CustomBusinessHoursScheduleDetailVM> {
  
    return CommonServices.defaultPost<OM.CustomBusinessHoursScheduleDetailVM>(baseUrl + 'api/ConsulenteCategory/OverrideDefaultBusinessHoursSchedule', consulenteCategoryBusinessHoursScheduleMakeDefaultVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  makeDefault(consulenteCategoryMakeDefaultVM : OM.ConsulenteCategoryMakeDefaultVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/ConsulenteCategory/MakeDefault', consulenteCategoryMakeDefaultVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  



  

  updateAudio(consulenteIdentifier : string, categoryIdentifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/ConsulenteCategory/UpdateAudio?consulenteIdentifier=' + consulenteIdentifier + '&categoryIdentifier=' + categoryIdentifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  



  

  updateVideo(consulenteIdentifier : string, categoryIdentifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/ConsulenteCategory/UpdateVideo?consulenteIdentifier=' + consulenteIdentifier + '&categoryIdentifier=' + categoryIdentifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addSpecialDaySchedule(vm : OM.ConsulenteCategorySpecialDayScheduleAddVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/ConsulenteCategory/AddSpecialDaySchedule', vm, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  editSpecialDaySchedule(vm : OM.ConsulenteCategorySpecialDayScheduleEditVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/ConsulenteCategory/EditSpecialDaySchedule', vm, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  removeSpecialDaySchedule(vm : OM.ConsulenteCategorySpecialDayScheduleRemoveVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/ConsulenteCategory/RemoveSpecialDaySchedule', vm, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateMinimumBookingNoticeDays(vm : OM.ConsulenteCategoryUpdateMinimumBookingNoticeDaysVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/ConsulenteCategory/UpdateMinimumBookingNoticeDays', vm, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllSpecialDays(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfConsulenteCategorySpecialDayScheduleDetailVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfConsulenteCategorySpecialDayScheduleDetailVM>(baseUrl + 'api/ConsulenteCategory/GetAllSpecialDays', paramsObject, showSpinner, responseType)
  }
}
export let ConsulenteCategoryClient = new _ConsulenteCategoryClient();

class _ContractClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  




  

  getByCompanyPaged(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfContract> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfContract>(baseUrl + 'api/Contract/GetByCompanyPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(contractCreateVM : OM.ContractCreateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Contract/Create', contractCreateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateBaseInfo(contractUpdateBaseInfoVM : OM.ContractUpdateBaseInfoVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Contract/UpdateBaseInfo', contractUpdateBaseInfoVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateMeetingsInformation(contractUpdateMeetingsInformationVM : OM.ContractUpdateMeetingsInformationVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Contract/UpdateMeetingsInformation', contractUpdateMeetingsInformationVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateCategorySettings(contractUpdateCategorySettingsVM : OM.ContractUpdateCategorySettingsVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Contract/UpdateCategorySettings', contractUpdateCategorySettingsVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  enable(contractIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/Contract/Enable', { contractIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  disable(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/Contract/Disable', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  

  

  getCategoryAvailable(companyIdentifier : string, appUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/Contract/GetCategoryAvailable', { companyIdentifier, appUserIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getCurrentActiveContract(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.Contract> {
  
    return CommonServices.defaultGet<OM.Contract>(baseUrl + 'api/Contract/GetCurrentActiveContract', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  


  

  getCategoryAvailableByConsulente(companyIdentifier : string, appUserIdentifier : string, consulenteIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/Contract/GetCategoryAvailableByConsulente', { companyIdentifier, appUserIdentifier, consulenteIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  


  

  getConsulenteAvailable(companyIdentifier : string, appUserIdentifier : string, categoryIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/Contract/GetConsulenteAvailable', { companyIdentifier, appUserIdentifier, categoryIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  


  

  getRemainingBooking(appUserIdentifier : string, categoryIdentifier : string, isForFamigliare : boolean, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.RemainingBookingVM> {
  
    return CommonServices.defaultGet<OM.RemainingBookingVM>(baseUrl + 'api/Contract/GetRemainingBooking', { appUserIdentifier, categoryIdentifier, isForFamigliare }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getBookingForm(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseFieldWithBookingConfigurationTypeBM[]> {
  
    return CommonServices.defaultGet<OM.BaseFieldWithBookingConfigurationTypeBM[]>(baseUrl + 'api/Contract/GetBookingForm', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAllCompanyTextIdentifierByConsulente(consulenteIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/Contract/GetAllCompanyTextIdentifierByConsulente', { consulenteIdentifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyAcademyCategoryAvailable(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.CategoryDetailListBM[]> {
  
    return CommonServices.defaultGet<OM.CategoryDetailListBM[]>(baseUrl + 'api/Contract/GetMyAcademyCategoryAvailable', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyWebinarCategoryAvailable(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.CategoryDetailListBM[]> {
  
    return CommonServices.defaultGet<OM.CategoryDetailListBM[]>(baseUrl + 'api/Contract/GetMyWebinarCategoryAvailable', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getCategoryDetail(categoryIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserCategoryDetailVM> {
  
    return CommonServices.defaultGet<OM.AppUserCategoryDetailVM>(baseUrl + 'api/Contract/GetCategoryDetail', { categoryIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  

  

  getConsulenteDetail(categoryIdentifier : string, consulenteIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserConsulenteDetailVM> {
  
    return CommonServices.defaultGet<OM.AppUserConsulenteDetailVM>(baseUrl + 'api/Contract/GetConsulenteDetail', { categoryIdentifier, consulenteIdentifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyTotalIncontri(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.IncontriTotaliERimanentiBM> {
  
    return CommonServices.defaultGet<OM.IncontriTotaliERimanentiBM>(baseUrl + 'api/Contract/GetMyTotalIncontri', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyCategories(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.CategoryForCompanyBM[]> {
  
    return CommonServices.defaultGet<OM.CategoryForCompanyBM[]>(baseUrl + 'api/Contract/GetMyCategories', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  

  

  getMyRemainingBooking(categoryIdentifier : string, isForFamigliare : boolean, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.RemainingBookingVM> {
  
    return CommonServices.defaultGet<OM.RemainingBookingVM>(baseUrl + 'api/Contract/GetMyRemainingBooking', { categoryIdentifier, isForFamigliare }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  


  

  getCalendarOfConsulente(consulenteIdentifier : string, categoryIdentifier : string, fromDate : string, toDate : string, ianaTimezone : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.OrariPerPrenotareBM[]> {
  
    return CommonServices.defaultGet<OM.OrariPerPrenotareBM[]>(baseUrl + 'api/Contract/GetCalendarOfConsulente', { consulenteIdentifier, categoryIdentifier, fromDate, toDate, ianaTimezone }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getCalendarOfCategory(categoryIdentifier : string, fromDate : string, toDate : string, ianaTimezone : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.OrariPerPrenotareBM[]> {
  
    return CommonServices.defaultGet<OM.OrariPerPrenotareBM[]>(baseUrl + 'api/Contract/GetCalendarOfCategory', { categoryIdentifier, fromDate, toDate, ianaTimezone }, showSpinner, responseType)
  }
}
export let ContractClient = new _ContractClient();

class _FamilyInvitationClient {

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createInvitation(request : OM.FamilyInvitationCreateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/FamilyInvitation/CreateInvitation', request, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfFamilyInvitationListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfFamilyInvitationListVM>(baseUrl + 'api/FamilyInvitation/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getInvitationsByUser(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.FamilyInvitationResponseVM[]> {
  
    return CommonServices.defaultGet<OM.FamilyInvitationResponseVM[]>(baseUrl + 'api/FamilyInvitation/GetInvitationsByUser', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  

  

  getInvitationDetails(invitationId : string, otpCode : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.FamilyInvitationDetailsVM> {
  
    return CommonServices.defaultGet<OM.FamilyInvitationDetailsVM>(baseUrl + 'api/FamilyInvitation/GetInvitationDetails/{invitationId}/{otpCode}', { invitationId, otpCode }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  acceptInvitation(request : OM.AcceptInvitationVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/FamilyInvitation/AcceptInvitation', request, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  rejectInvitation(request : OM.RejectInvitationVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/FamilyInvitation/RejectInvitation', request, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  deletePendingInvitation(invitationId : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultDelete<void>(baseUrl + 'api/FamilyInvitation/DeletePendingInvitation/{invitationId}', { invitationId }, showSpinner, responseType)
  }
}
export let FamilyInvitationClient = new _FamilyInvitationClient();

class _FaqEntryClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfFaqEntry> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfFaqEntry>(baseUrl + 'api/FaqEntry/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(faqEntryCreateVM : OM.FaqEntryCreateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/FaqEntry/Create', faqEntryCreateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  enable(faqIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/FaqEntry/Enable', { faqIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  disable(faqIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/FaqEntry/Disable', { faqIdentifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyFaq(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserFaqListVM[]> {
  
    return CommonServices.defaultGet<OM.AppUserFaqListVM[]>(baseUrl + 'api/FaqEntry/GetMyFaq', {  }, showSpinner, responseType)
  }
}
export let FaqEntryClient = new _FaqEntryClient();

class _FieldCombinationClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfTextFieldCombination> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfTextFieldCombination>(baseUrl + 'api/FieldCombination/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createTextFieldCombination(createTextFieldCombinationVM : OM.CreateTextFieldCombinationVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/FieldCombination/CreateTextFieldCombination', createTextFieldCombinationVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateTextFieldCombination(updateTextFieldCombinationVM : OM.UpdateTextFieldCombinationVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/FieldCombination/UpdateTextFieldCombination', updateTextFieldCombinationVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  

  

  updateValuesWithFile(identifier : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/FieldCombination/UpdateValuesWithFile?identifier=' + identifier, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllAsTextIdentifier(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.FieldCombinationListVM[]> {
  
    return CommonServices.defaultGet<OM.FieldCombinationListVM[]>(baseUrl + 'api/FieldCombination/GetAllAsTextIdentifier', {  }, showSpinner, responseType)
  }
}
export let FieldCombinationClient = new _FieldCombinationClient();

class _FieldClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBaseField> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBaseField>(baseUrl + 'api/Field/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllTextField(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextField[]> {
  
    return CommonServices.defaultGet<OM.TextField[]>(baseUrl + 'api/Field/GetAllTextField', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllAsTextIdentifier(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/Field/GetAllAsTextIdentifier', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createCheckbox(createFieldWithOptionsVM : OM.CreateFieldWithOptionsVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Field/CreateCheckbox', createFieldWithOptionsVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateCheckbox(updateFieldWithOptionsVM : OM.UpdateFieldWithOptionsVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Field/UpdateCheckbox', updateFieldWithOptionsVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createDate(createDateFieldVM : OM.CreateDateFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Field/CreateDate', createDateFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateDate(updateDateFieldVM : OM.UpdateDateFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Field/UpdateDate', updateDateFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createNumber(createNumberFieldVM : OM.CreateNumberFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Field/CreateNumber', createNumberFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateNumber(updateNumberFieldVM : OM.UpdateNumberFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Field/UpdateNumber', updateNumberFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createRadio(createFieldWithOptionsVM : OM.CreateFieldWithOptionsVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Field/CreateRadio', createFieldWithOptionsVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateRadio(updateFieldWithOptionsVM : OM.UpdateFieldWithOptionsVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Field/UpdateRadio', updateFieldWithOptionsVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createSelect(createFieldWithOptionsVM : OM.CreateFieldWithOptionsVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Field/CreateSelect', createFieldWithOptionsVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateSelect(updateFieldWithOptionsVM : OM.UpdateFieldWithOptionsVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Field/UpdateSelect', updateFieldWithOptionsVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createText(createTextFieldVM : OM.CreateTextFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Field/CreateText', createTextFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateText(updateTextFieldVM : OM.UpdateTextFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Field/UpdateText', updateTextFieldVM, { }, showSpinner, responseType)
  }
}
export let FieldClient = new _FieldClient();

class _LoginLogClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfLoginLogListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfLoginLogListVM>(baseUrl + 'api/LoginLog/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getFilters(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.LoginLogFilterVM> {
  
    return CommonServices.defaultGet<OM.LoginLogFilterVM>(baseUrl + 'api/LoginLog/GetFilters', {  }, showSpinner, responseType)
  }
}
export let LoginLogClient = new _LoginLogClient();

class _StripeClient {

  

  

  


  

  
  
  
  

  

  getSavedCards(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.StripeCardDetailBM[]> {
  
    return CommonServices.defaultGet<OM.StripeCardDetailBM[]>(baseUrl + 'api/Stripe/GetSavedCards', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addCardToCustomer(paymentMethodId : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.StripeCardDetailBM> {
  
    return CommonServices.defaultGet<OM.StripeCardDetailBM>(baseUrl + 'api/Stripe/AddCardToCustomer', { paymentMethodId }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  removeCardFromCustomer(paymentMethodId : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/Stripe/RemoveCardFromCustomer', { paymentMethodId }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  

  

  createIntent(model : any, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Stripe/CreateIntent', model, undefined, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createIntentForCategoryPayment(model : any, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Stripe/CreateIntentForCategoryPayment', model, undefined, showSpinner, responseType)
  }
}
export let StripeClient = new _StripeClient();

class _ViewModelClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfViewModel> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfViewModel>(baseUrl + 'api/ViewModel/GetAllPaged', paramsObject, showSpinner, responseType)
  }
}
export let ViewModelClient = new _ViewModelClient();

class _VoteModelClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfVoteModel> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfVoteModel>(baseUrl + 'api/VoteModel/GetAllPaged', paramsObject, showSpinner, responseType)
  }
}
export let VoteModelClient = new _VoteModelClient();

class _WebinarContentClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfWebinarContent> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfWebinarContent>(baseUrl + 'api/WebinarContent/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(webinarContentCreateVM : OM.WebinarContentCreateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/WebinarContent/Create', webinarContentCreateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  update(webinarContentUpdateVM : OM.WebinarContentUpdateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/WebinarContent/Update', webinarContentUpdateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  


  

  updateImage(identifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/WebinarContent/UpdateImage?identifier=' + identifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  enable(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/WebinarContent/Enable', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  disable(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/WebinarContent/Disable', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAppUserWebinairDetail(webinairIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserWebinairDetailVM> {
  
    return CommonServices.defaultGet<OM.AppUserWebinairDetailVM>(baseUrl + 'api/WebinarContent/GetAppUserWebinairDetail', { webinairIdentifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyWebinarList(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserWebinairListVM[]> {
  
    return CommonServices.defaultGet<OM.AppUserWebinairListVM[]>(baseUrl + 'api/WebinarContent/GetMyWebinarList', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getComments(contentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserCommentListVM[]> {
  
    return CommonServices.defaultGet<OM.AppUserCommentListVM[]>(baseUrl + 'api/WebinarContent/GetComments', { contentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addView(contentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/WebinarContent/AddView', { contentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getUserVote(contentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<number> {
  
    return CommonServices.defaultGet<number>(baseUrl + 'api/WebinarContent/GetUserVote', { contentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createVote(createVoteVM : OM.CreateVoteVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/WebinarContent/CreateVote', createVoteVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createComment(createCommentVM : OM.CreateCommentVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/WebinarContent/CreateComment', createCommentVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getQuestionCount(contentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.QuestionCountVM> {
  
    return CommonServices.defaultGet<OM.QuestionCountVM>(baseUrl + 'api/WebinarContent/GetQuestionCount', { contentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAdminQuestions(contentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AdminQuestionListVM[]> {
  
    return CommonServices.defaultGet<OM.AdminQuestionListVM[]>(baseUrl + 'api/WebinarContent/GetAdminQuestions', { contentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  replyToQuestion(replyVM : OM.ReplyToQuestionVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/WebinarContent/ReplyToQuestion', replyVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

  

  
  
  
  

  

  delete(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/WebinarContent/Delete?identifier=' + identifier, { }, { }, showSpinner, responseType)
  }
}
export let WebinarContentClient = new _WebinarContentClient();

class _AppUserClient {

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  confirmUser(confirmUserVM : OM.ConfirmUserVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseApiLoginResponseOfLoggedUserVM> {
  
    return CommonServices.defaultPost<OM.BaseApiLoginResponseOfLoggedUserVM>(baseUrl + 'api/AppUser/ConfirmUser', confirmUserVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  changePassword(changePasswordVM : OM.ChangePasswordVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AppUser/ChangePassword', changePasswordVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  forgotPassword(username : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/ForgotPassword', { username }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllUserStats(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserStatsVM> {
  
    return CommonServices.defaultGet<OM.AppUserStatsVM>(baseUrl + 'api/AppUser/GetAllUserStats', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfAppUserListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfAppUserListVM>(baseUrl + 'api/AppUser/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPagedByConsulente(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfAppUserConsulenteListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfAppUserConsulenteListVM>(baseUrl + 'api/AppUser/GetAllPagedByConsulente', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(appUserCreateVM : OM.AppUserCreateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/AppUser/Create', appUserCreateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getUserAdditionalData(userIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<{ [key: string]: string[]; }> {
  
    return CommonServices.defaultGet<{ [key: string]: string[]; }>(baseUrl + 'api/AppUser/GetUserAdditionalData', { userIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  enable(appUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/Enable', { appUserIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  disable(appUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/Disable', { appUserIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAllAsTextIdentifierByCompany(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifierType[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifierType[]>(baseUrl + 'api/AppUser/GetAllAsTextIdentifierByCompany', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyPersonalData(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PersonalData> {
  
    return CommonServices.defaultGet<OM.PersonalData>(baseUrl + 'api/AppUser/GetMyPersonalData', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateNameAndSurname(updateNameAndSurnameVM : OM.UpdateNameAndSurnameVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AppUser/UpdateNameAndSurname', updateNameAndSurnameVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  registerUser(appUserRegisterVM : OM.AppUserRegisterVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AppUser/RegisterUser', appUserRegisterVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  loginUser(appUserLoginVM : OM.AppUserLoginVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseApiLoginResponseOfLoggedUserVM> {
  
    return CommonServices.defaultPost<OM.BaseApiLoginResponseOfLoggedUserVM>(baseUrl + 'api/AppUser/LoginUser', appUserLoginVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  sendNewConfirmationlink(email : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/SendNewConfirmationlink', { email }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  changeEmail(changeEmailVM : OM.ChangeEmailVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AppUser/ChangeEmail', changeEmailVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  setEmailConfirmed(appUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/SetEmailConfirmed', { appUserIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  unsetEmailConfirmed(appUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/UnsetEmailConfirmed', { appUserIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  isFamilyUser(email : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<boolean> {
  
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/AppUser/IsFamilyUser', { email }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  resetConfirmationCode(username : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/ResetConfirmationCode', { username }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  refreshToken(tokens : OM.RefreshTokenVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseApiLoginResponseOfLoggedUserVM> {
  
    return CommonServices.defaultPost<OM.BaseApiLoginResponseOfLoggedUserVM>(baseUrl + 'api/AppUser/RefreshToken', tokens, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  resetPassword(username : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/ResetPassword', { username }, showSpinner, responseType)
  }
}
export let AppUserClient = new _AppUserClient();

class _BackofficeUserClient {

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  confirmUser(confirmUserVM : OM.ConfirmUserVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseApiLoginResponseOfLoggedUserVM> {
  
    return CommonServices.defaultPost<OM.BaseApiLoginResponseOfLoggedUserVM>(baseUrl + 'api/BackofficeUser/ConfirmUser', confirmUserVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  login(model : OM.CultureBaseCredential, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseApiLoginResponseOfLoggedUserVM> {
  
    return CommonServices.defaultPost<OM.BaseApiLoginResponseOfLoggedUserVM>(baseUrl + 'api/BackofficeUser/Login', model, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  changePassword(changePasswordVM : OM.ChangePasswordVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/BackofficeUser/ChangePassword', changePasswordVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  forgotPassword(username : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BackofficeUser/ForgotPassword', { username }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  refreshToken(tokens : OM.RefreshTokenVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseApiLoginResponseOfLoggedUserVM> {
  
    return CommonServices.defaultPost<OM.BaseApiLoginResponseOfLoggedUserVM>(baseUrl + 'api/BackofficeUser/RefreshToken', tokens, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  sendNewConfirmationlink(email : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BackofficeUser/SendNewConfirmationlink', { email }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  resetConfirmationCode(username : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BackofficeUser/ResetConfirmationCode', { username }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  resetPassword(username : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BackofficeUser/ResetPassword', { username }, showSpinner, responseType)
  }
}
export let BackofficeUserClient = new _BackofficeUserClient();

class _BaseUserClient {

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  setFcmId(fcmId : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BaseUser/SetFcmId', { fcmId }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  changeLanguageAndGetToken(language : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultGet<string>(baseUrl + 'api/BaseUser/ChangeLanguageAndGetToken', { language }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  resetConfirmationCode(username : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BaseUser/ResetConfirmationCode', { username }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  confirm(confirmVM : OM.ConfirmVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseApiLoginResponseOfLoggedUserVM> {
  
    return CommonServices.defaultPost<OM.BaseApiLoginResponseOfLoggedUserVM>(baseUrl + 'api/BaseUser/Confirm', confirmVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  changePassword(newPassword : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BaseUser/ChangePassword', { newPassword }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  refreshToken(tokens : OM.RefreshTokenVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BaseApiLoginResponseOfLoggedUserVM> {
  
    return CommonServices.defaultPost<OM.BaseApiLoginResponseOfLoggedUserVM>(baseUrl + 'api/BaseUser/RefreshToken', tokens, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  resetPassword(username : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BaseUser/ResetPassword', { username }, showSpinner, responseType)
  }
}
export let BaseUserClient = new _BaseUserClient();

class _ConsulenteUserClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfConsulenteUserListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfConsulenteUserListVM>(baseUrl + 'api/ConsulenteUser/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllTimezone(showSpinner = true, responseType: ResponseType = 'json') : Promise<{ [key: string]: OM.CustomTimezoneInfo; }> {
  
    return CommonServices.defaultGet<{ [key: string]: OM.CustomTimezoneInfo; }>(baseUrl + 'api/ConsulenteUser/GetAllTimezone', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyTimezone(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.CustomTimezoneInfo> {
  
    return CommonServices.defaultGet<OM.CustomTimezoneInfo>(baseUrl + 'api/ConsulenteUser/GetMyTimezone', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getConsulenteTextIdentifier(consulenteIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier> {
  
    return CommonServices.defaultGet<OM.TextIdentifier>(baseUrl + 'api/ConsulenteUser/GetConsulenteTextIdentifier', { consulenteIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getDetail(consulenteUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.ConsulenteUserDetailVM> {
  
    return CommonServices.defaultGet<OM.ConsulenteUserDetailVM>(baseUrl + 'api/ConsulenteUser/GetDetail', { consulenteUserIdentifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyDetail(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.ConsulenteUserDetailVM> {
  
    return CommonServices.defaultGet<OM.ConsulenteUserDetailVM>(baseUrl + 'api/ConsulenteUser/GetMyDetail', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(consulenteUserCreateVM : OM.ConsulenteUserCreateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/ConsulenteUser/Create', consulenteUserCreateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  enable(consulenteUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/ConsulenteUser/Enable', { consulenteUserIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  disable(consulenteUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/ConsulenteUser/Disable', { consulenteUserIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  


  

  updateImage(identifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/ConsulenteUser/UpdateImage?identifier=' + identifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  confirmUser(confirmUserVM : OM.ConfirmUserVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/ConsulenteUser/ConfirmUser', confirmUserVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  setEmailConfirmed(consulenteUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/ConsulenteUser/SetEmailConfirmed', { consulenteUserIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  unsetEmailConfirmed(consulenteUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/ConsulenteUser/UnsetEmailConfirmed', { consulenteUserIdentifier }, showSpinner, responseType)
  }
}
export let ConsulenteUserClient = new _ConsulenteUserClient();

class _AdminSupportAvailabilityClient {

  

  

  


  

  
  
  
  

  

  getMyAvailability(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AdminSupportAvailabilityVM> {
  
    return CommonServices.defaultGet<OM.AdminSupportAvailabilityVM>(baseUrl + 'api/AdminSupportAvailability/GetMyAvailability', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createOrUpdate(updateVM : OM.UpdateAdminSupportAvailabilityVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/AdminSupportAvailability/CreateOrUpdate', updateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateBusinessHoursSchedule(updateVM : OM.UpdateBusinessHoursScheduleVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AdminSupportAvailability/UpdateBusinessHoursSchedule', updateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateAvailability(updateVM : OM.UpdateAdminSupportAvailabilityVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AdminSupportAvailability/UpdateAvailability', updateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateMinimumBookingNoticeDays(updateVM : OM.UpdateMinimumBookingNoticeDaysVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AdminSupportAvailability/UpdateMinimumBookingNoticeDays', updateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addBusinessHoursSchedule(addVM : OM.AddAdminSupportHoursVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/AdminSupportAvailability/AddBusinessHoursSchedule', addVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  editBusinessHoursSchedule(editVM : OM.EditAdminSupportHoursVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AdminSupportAvailability/EditBusinessHoursSchedule', editVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  removeBusinessHoursSchedule(removeVM : OM.RemoveAdminSupportHoursVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/AdminSupportAvailability/RemoveBusinessHoursSchedule', removeVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAvailableSlots(date : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AvailableSlotVM[]> {
  
    return CommonServices.defaultGet<OM.AvailableSlotVM[]>(baseUrl + 'api/AdminSupportAvailability/GetAvailableSlots', { date }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getForMyCompany(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AdminSupportAvailabilityPublicVM> {
  
    return CommonServices.defaultGet<OM.AdminSupportAvailabilityPublicVM>(baseUrl + 'api/AdminSupportAvailability/GetForMyCompany', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAvailableSlotsForUser(date : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AvailableSlotVM[]> {
  
    return CommonServices.defaultGet<OM.AvailableSlotVM[]>(baseUrl + 'api/AdminSupportAvailability/GetAvailableSlotsForUser', { date }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  

  

  getCalendarSlotsForUser(startDate : string, endDate : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.OrariPerPrenotareBM[]> {
  
    return CommonServices.defaultGet<OM.OrariPerPrenotareBM[]>(baseUrl + 'api/AdminSupportAvailability/GetCalendarSlotsForUser', { startDate, endDate }, showSpinner, responseType)
  }
}
export let AdminSupportAvailabilityClient = new _AdminSupportAvailabilityClient();

class _SupportMeetingClient {

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(createVM : OM.CreateSupportMeetingVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/SupportMeeting/Create', createVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getById(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.SupportMeetingListVM> {
  
    return CommonServices.defaultGet<OM.SupportMeetingListVM>(baseUrl + 'api/SupportMeeting/GetById', { identifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyMeetings(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.SupportMeetingListVM[]> {
  
    return CommonServices.defaultGet<OM.SupportMeetingListVM[]>(baseUrl + 'api/SupportMeeting/GetMyMeetings', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyMeetingStats(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.SupportMeetingStatsVM> {
  
    return CommonServices.defaultGet<OM.SupportMeetingStatsVM>(baseUrl + 'api/SupportMeeting/GetMyMeetingStats', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  canBook(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.CanBookSupportMeetingVM> {
  
    return CommonServices.defaultGet<OM.CanBookSupportMeetingVM>(baseUrl + 'api/SupportMeeting/CanBook', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

  

  
  
  
  

  

  cancel(supportMeetingIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/SupportMeeting/Cancel?supportMeetingIdentifier=' + supportMeetingIdentifier, { }, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createByAdmin(createVM : OM.CreateSupportMeetingByAdminVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/SupportMeeting/CreateByAdmin', createVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfSupportMeetingAdminListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfSupportMeetingAdminListVM>(baseUrl + 'api/SupportMeeting/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  




  

  getByCompany(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfSupportMeetingAdminListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfSupportMeetingAdminListVM>(baseUrl + 'api/SupportMeeting/GetByCompany', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getMyAdminMeetings(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.SupportMeetingAdminListVM[]> {
  
    return CommonServices.defaultGet<OM.SupportMeetingAdminListVM[]>(baseUrl + 'api/SupportMeeting/GetMyAdminMeetings', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateLinkIncontro(updateVM : OM.UpdateLinkIncontroVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/SupportMeeting/UpdateLinkIncontro', updateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

  

  
  
  
  

  

  cancelByAdmin(supportMeetingIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/SupportMeeting/CancelByAdmin?supportMeetingIdentifier=' + supportMeetingIdentifier, { }, { }, showSpinner, responseType)
  }
}
export let SupportMeetingClient = new _SupportMeetingClient();

class _SpokenLanguageClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfSpokenLanguage> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfSpokenLanguage>(baseUrl + 'api/SpokenLanguage/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllAsTextIdentifier(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/SpokenLanguage/GetAllAsTextIdentifier', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(model : OM.SpokenLanguageCreateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/SpokenLanguage/Create', model, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  

  

  updateImage(spokenLanguageIdentifier : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/SpokenLanguage/UpdateImage?spokenLanguageIdentifier=' + spokenLanguageIdentifier, file, { }, progressFn, showSpinner, responseType)
  }
}
export let SpokenLanguageClient = new _SpokenLanguageClient();

class _MandatoryDocumentCategoryClient {

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(createMandatoryDocumentCategory : OM.MandatoryDocumentCategoryCreateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/MandatoryDocumentCategory/Create', createMandatoryDocumentCategory, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  edit(editMandatoryDocumentCategory : OM.MandatoryDocumentCategoryEditVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/MandatoryDocumentCategory/Edit', editMandatoryDocumentCategory, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfMandatoryDocumentCategoryListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfMandatoryDocumentCategoryListVM>(baseUrl + 'api/MandatoryDocumentCategory/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllAsTextIdentifier(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/MandatoryDocumentCategory/GetAllAsTextIdentifier', {  }, showSpinner, responseType)
  }
}
export let MandatoryDocumentCategoryClient = new _MandatoryDocumentCategoryClient();

class _MandatoryDocumentClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfMandatoryDocumentListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfMandatoryDocumentListVM>(baseUrl + 'api/MandatoryDocument/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createAppDocument(createMandatoryDocumentVM : OM.CreateMandatoryDocumentVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/MandatoryDocument/CreateAppDocument', createMandatoryDocumentVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  editAppDocument(editMandatoryDocumentVM : OM.EditMandatoryDocumentVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/MandatoryDocument/EditAppDocument', editMandatoryDocumentVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createBackofficeDocument(createMandatoryDocumentVM : OM.CreateMandatoryDocumentVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/MandatoryDocument/CreateBackofficeDocument', createMandatoryDocumentVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  editBackofficeDocument(editMandatoryDocumentVM : OM.EditMandatoryDocumentVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/MandatoryDocument/EditBackofficeDocument', editMandatoryDocumentVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  publish(documentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/MandatoryDocument/Publish', { documentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  hide(documentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/MandatoryDocument/Hide', { documentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  


  

  updateDocument(identifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/MandatoryDocument/UpdateDocument?identifier=' + identifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getBackofficeMustSign(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.MandatoryDocumentVM[]> {
  
    return CommonServices.defaultGet<OM.MandatoryDocumentVM[]>(baseUrl + 'api/MandatoryDocument/GetBackofficeMustSign', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getBackofficeMineDocumentToSign(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.MandatoryDocumentVM[]> {
  
    return CommonServices.defaultGet<OM.MandatoryDocumentVM[]>(baseUrl + 'api/MandatoryDocument/GetBackofficeMineDocumentToSign', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  acceptBackofficeDocumentToSign(showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/MandatoryDocument/AcceptBackofficeDocumentToSign', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAppMustSign(companyCode : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.MandatoryDocumentVM[]> {
  
    return CommonServices.defaultGet<OM.MandatoryDocumentVM[]>(baseUrl + 'api/MandatoryDocument/GetAppMustSign', { companyCode }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAppMineDocumentToSign(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.MandatoryDocumentVM[]> {
  
    return CommonServices.defaultGet<OM.MandatoryDocumentVM[]>(baseUrl + 'api/MandatoryDocument/GetAppMineDocumentToSign', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  acceptAppDocumentToSign(showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/MandatoryDocument/AcceptAppDocumentToSign', {  }, showSpinner, responseType)
  }
}
export let MandatoryDocumentClient = new _MandatoryDocumentClient();

class _LocalResourceContryClient {

  

  

  


  

  
  
  
  

  

  getExtendedCountries(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.ExtendedCountry[]> {
  
    return CommonServices.defaultGet<OM.ExtendedCountry[]>(baseUrl + 'api/LocalResourceContry/GetExtendedCountries', {  }, showSpinner, responseType)
  }
}
export let LocalResourceContryClient = new _LocalResourceContryClient();

class _MailEventClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  




  

  getAll(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfMailEventListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfMailEventListVM>(baseUrl + 'api/MailEvent/GetAll', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getFilters(parentIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.MailEventFilterVM> {
  
    return CommonServices.defaultGet<OM.MailEventFilterVM>(baseUrl + 'api/MailEvent/GetFilters', { parentIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getByID(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.MailEventVM> {
  
    return CommonServices.defaultGet<OM.MailEventVM>(baseUrl + 'api/MailEvent/GetByID', { identifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  requestMessageDetail(messageId : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.MailjetResponseVMOfGetMessageDataVM> {
  
    return CommonServices.defaultGet<OM.MailjetResponseVMOfGetMessageDataVM>(baseUrl + 'api/MailEvent/RequestMessageDetail', { messageId }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  sendMessageAgain(sendMessageAgainVM : OM.SendMessageAgainVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/MailEvent/SendMessageAgain', sendMessageAgainVM, { }, showSpinner, responseType)
  }
}
export let MailEventClient = new _MailEventClient();

class _TransactionClient {

  

  

  


  

  
  
  
  

  

  getMyTransactions(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.Transaction[]> {
  
    return CommonServices.defaultGet<OM.Transaction[]>(baseUrl + 'api/Transaction/GetMyTransactions', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(item : OM.AppUserTransactionCreateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TransactionAndBoughPackageIdsBM> {
  
    return CommonServices.defaultPost<OM.TransactionAndBoughPackageIdsBM>(baseUrl + 'api/Transaction/Create', item, { }, showSpinner, responseType)
  }
}
export let TransactionClient = new _TransactionClient();

class _AttachmentEntityClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfAttachmentLocalizedEntity> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfAttachmentLocalizedEntity>(baseUrl + 'api/AttachmentEntity/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAll(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AttachmentLocalizedEntity[]> {
  
    return CommonServices.defaultGet<OM.AttachmentLocalizedEntity[]>(baseUrl + 'api/AttachmentEntity/GetAll', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  


  

  editLocalizedValue(identifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/AttachmentEntity/EditLocalizedValue?identifier=' + identifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }
}
export let AttachmentEntityClient = new _AttachmentEntityClient();

class _LocalizedEntityClient {

  

  

  


  

  
  
  
  

  

  getAllBackoffice(showSpinner = true, responseType: ResponseType = 'json') : Promise<{ [key: string]: string; }> {
  
    return CommonServices.defaultGet<{ [key: string]: string; }>(baseUrl + 'api/LocalizedEntity/GetAllBackoffice', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAllApp(companyCode : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<{ [key: string]: string; }> {
  
    return CommonServices.defaultGet<{ [key: string]: string; }>(baseUrl + 'api/LocalizedEntity/GetAllApp', { companyCode }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getEnabledLanguages(showSpinner = true, responseType: ResponseType = 'json') : Promise<string[]> {
  
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/LocalizedEntity/GetEnabledLanguages', {  }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getSupportedLanguages(showSpinner = true, responseType: ResponseType = 'json') : Promise<string[]> {
  
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/LocalizedEntity/GetSupportedLanguages', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  saveLocalizedValue(item : OM.KeyValuePairOfStringAndString, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/LocalizedEntity/SaveLocalizedValue', item, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfLocalizedEntity> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfLocalizedEntity>(baseUrl + 'api/LocalizedEntity/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAll(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.LocalizedEntity[]> {
  
    return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/LocalizedEntity/GetAll', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  editLocalizedValue(value : OM.LocalizedEntity, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/LocalizedEntity/EditLocalizedValue', value, { }, showSpinner, responseType)
  }
}
export let LocalizedEntityClient = new _LocalizedEntityClient();

class _OverrideAttachmentLocalizedEntityClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfOverrideAttachmentLocalizedEntity> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfOverrideAttachmentLocalizedEntity>(baseUrl + 'api/OverrideAttachmentLocalizedEntity/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  



  

  create(referenceIdentifier : string, companyIdentifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/OverrideAttachmentLocalizedEntity/Create?referenceIdentifier=' + referenceIdentifier + '&companyIdentifier=' + companyIdentifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  

    

    

    

    

      

    

    

    

    

      

    

    

    

    


  

  

  
  
  
  


  

  edit(identifier : string, language : string, file : File | string, progressFn: ((prog: any) => void) | null = null, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/OverrideAttachmentLocalizedEntity/Edit?identifier=' + identifier + '&language=' + language, file, { }, progressFn, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  delete(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/OverrideAttachmentLocalizedEntity/Delete', { identifier }, showSpinner, responseType)
  }
}
export let OverrideAttachmentLocalizedEntityClient = new _OverrideAttachmentLocalizedEntityClient();

class _OverrideLocalizedEntityClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfOverrideLocalizedEntity> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfOverrideLocalizedEntity>(baseUrl + 'api/OverrideLocalizedEntity/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(createOverrideLocalizedEntityVM : OM.CreateOverrideLocalizedEntityVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/OverrideLocalizedEntity/Create', createOverrideLocalizedEntityVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  edit(editOverrideLocalizedEntityVM : OM.EditOverrideLocalizedEntityVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/OverrideLocalizedEntity/Edit', editOverrideLocalizedEntityVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  delete(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/OverrideLocalizedEntity/Delete', { identifier }, showSpinner, responseType)
  }
}
export let OverrideLocalizedEntityClient = new _OverrideLocalizedEntityClient();

class _BookingClient {

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createReservation(createBookingVM : OM.CreateBookingVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Booking/CreateReservation', createBookingVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  




  

  getByCompany(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBookingAdminListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBookingAdminListVM>(baseUrl + 'api/Booking/GetByCompany', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateLinkIncontro(updateLinkIncontroVM : OM.UpdateLinkIncontroVM2, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Booking/UpdateLinkIncontro', updateLinkIncontroVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  




  

  getByUser(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBookingAdminListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBookingAdminListVM>(baseUrl + 'api/Booking/GetByUser', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllAsPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBookingAdminListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBookingAdminListVM>(baseUrl + 'api/Booking/GetAllAsPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getMyReservation(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBookingAdminListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBookingAdminListVM>(baseUrl + 'api/Booking/GetMyReservation', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  




  

  getByConsulente(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBookingAdminListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBookingAdminListVM>(baseUrl + 'api/Booking/GetByConsulente', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  

  

  getUserAdditionalData(appUserIdentifier : string, categoryIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BookingUserAdditionalDataVM> {
  
    return CommonServices.defaultGet<OM.BookingUserAdditionalDataVM>(baseUrl + 'api/Booking/GetUserAdditionalData', { appUserIdentifier, categoryIdentifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllMine(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserBookingListVM[]> {
  
    return CommonServices.defaultGet<OM.AppUserBookingListVM[]>(baseUrl + 'api/Booking/GetAllMine', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getMyBooking(bookingIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserBookingDetailVM> {
  
    return CommonServices.defaultGet<OM.AppUserBookingDetailVM>(baseUrl + 'api/Booking/GetMyBooking', { bookingIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  cancelReservation(bookingIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/Booking/CancelReservation', { bookingIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  cancelReservationByAdmin(bookingIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/Booking/CancelReservationByAdmin', { bookingIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateOverrideCategoryCountedAsReservationVM(updateOverrideCategoryCountedAsReservationVM : OM.UpdateOverrideCategoryCountedAsReservationVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Booking/UpdateOverrideCategoryCountedAsReservationVM', updateOverrideCategoryCountedAsReservationVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  




  

  getByUserForConsulente(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBookingAdminListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBookingAdminListVM>(baseUrl + 'api/Booking/GetByUserForConsulente', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  cancelReservationByConsulente(bookingIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/Booking/CancelReservationByConsulente', { bookingIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  updateOverrideCategoryCountedAsReservationByConsulente(updateOverrideCategoryCountedAsReservationVM : OM.UpdateOverrideCategoryCountedAsReservationVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Booking/UpdateOverrideCategoryCountedAsReservationByConsulente', updateOverrideCategoryCountedAsReservationVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createReservationByConsulente(createBookingVM : OM.CreateBookingVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Booking/CreateReservationByConsulente', createBookingVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createReservationByAdminForConsulente(createBookingVM : OM.CreateBookingVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Booking/CreateReservationByAdminForConsulente', createBookingVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createBooking(appUserCreateBookingVM : OM.AppUserCreateBookingVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Booking/CreateBooking', appUserCreateBookingVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createBookingFirstConsulentAvailable(appUserCreateBookingFirstConsulentAvailableVM : OM.AppUserCreateBookingFirstConsulentAvailableVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/Booking/CreateBookingFirstConsulentAvailable', appUserCreateBookingFirstConsulentAvailableVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getMyAdditionalData(categoryIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BookingUserAdditionalDataVM> {
  
    return CommonServices.defaultGet<OM.BookingUserAdditionalDataVM>(baseUrl + 'api/Booking/GetMyAdditionalData', { categoryIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  changeBookingDate(appUserChangeBookingDateVM : OM.AppUserChangeBookingDateVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/Booking/ChangeBookingDate', appUserChangeBookingDateVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getCompletedBookingsCountByCategory(appUserIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.CategoryBookingCountVM[]> {
  
    return CommonServices.defaultGet<OM.CategoryBookingCountVM[]>(baseUrl + 'api/Booking/GetCompletedBookingsCountByCategory', { appUserIdentifier }, showSpinner, responseType)
  }
}
export let BookingClient = new _BookingClient();

class _BookingRequestClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBookingRequest> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBookingRequest>(baseUrl + 'api/BookingRequest/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  isThereAPendingRequest(showSpinner = true, responseType: ResponseType = 'json') : Promise<boolean> {
  
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/BookingRequest/IsThereAPendingRequest', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  rejectRequest(rejectRequestVM : OM.RejectRequestVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/BookingRequest/RejectRequest', rejectRequestVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  acceptRequest(acceptRequestVM : OM.AcceptRequestVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/BookingRequest/AcceptRequest', acceptRequestVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  voidMyRequest(requestIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BookingRequest/VoidMyRequest', { requestIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getMyActiveRequest(categoryIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.AppUserBookingRequestVM> {
  
    return CommonServices.defaultGet<OM.AppUserBookingRequestVM>(baseUrl + 'api/BookingRequest/GetMyActiveRequest', { categoryIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createRequest(appUserCreateRequestVM : OM.AppUserCreateRequestVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/BookingRequest/CreateRequest', appUserCreateRequestVM, { }, showSpinner, responseType)
  }
}
export let BookingRequestClient = new _BookingRequestClient();

class _HolidayBookingClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfHolidayBooking> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfHolidayBooking>(baseUrl + 'api/HolidayBooking/GetAllPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getMinePaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfHolidayBookingConsulenteListVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfHolidayBookingConsulenteListVM>(baseUrl + 'api/HolidayBooking/GetMinePaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  create(createHolidayBookingVM : OM.CreateHolidayBookingVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/HolidayBooking/Create', createHolidayBookingVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  createMyHoliday(createMyHolidayBookingVM : OM.CreateMyHolidayBookingVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<string> {
  
    return CommonServices.defaultPost<string>(baseUrl + 'api/HolidayBooking/CreateMyHoliday', createMyHolidayBookingVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  update(updateHolidayBookingVM : OM.UpdateHolidayBookingVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultPost<void>(baseUrl + 'api/HolidayBooking/Update', updateHolidayBookingVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  disable(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/HolidayBooking/Disable', { identifier }, showSpinner, responseType)
  }
}
export let HolidayBookingClient = new _HolidayBookingClient();

class _BookingConfigurationClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllDefaultPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBookingConfiguration> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBookingConfiguration>(baseUrl + 'api/BookingConfiguration/GetAllDefaultPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  




  

  getByCompanyPaged(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfBookingConfigurationVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfBookingConfigurationVM>(baseUrl + 'api/BookingConfiguration/GetByCompanyPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAllCompanyTextCombination(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BookingConfiguration[]> {
  
    return CommonServices.defaultGet<OM.BookingConfiguration[]>(baseUrl + 'api/BookingConfiguration/GetAllCompanyTextCombination', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllDefaultAsList(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifierWithBookingConfigurationTypeVM[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifierWithBookingConfigurationTypeVM[]>(baseUrl + 'api/BookingConfiguration/GetAllDefaultAsList', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  getAllByCompanyAsList(companyIdentifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifierWithBookingConfigurationTypeVM[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifierWithBookingConfigurationTypeVM[]>(baseUrl + 'api/BookingConfiguration/GetAllByCompanyAsList', { companyIdentifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  delete(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/BookingConfiguration/Delete', { identifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addDefaultBaseField(addDefaultBookingBaseFieldVM : OM.AddDefaultBookingBaseFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BookingConfiguration> {
  
    return CommonServices.defaultPost<OM.BookingConfiguration>(baseUrl + 'api/BookingConfiguration/AddDefaultBaseField', addDefaultBookingBaseFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addBaseField(addBookingBaseFieldVM : OM.AddBookingBaseFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BookingConfiguration> {
  
    return CommonServices.defaultPost<OM.BookingConfiguration>(baseUrl + 'api/BookingConfiguration/AddBaseField', addBookingBaseFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addDefaultFieldCombination(addDefaultBookingCombinationFieldVM : OM.AddDefaultBookingCombinationFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BookingConfiguration> {
  
    return CommonServices.defaultPost<OM.BookingConfiguration>(baseUrl + 'api/BookingConfiguration/AddDefaultFieldCombination', addDefaultBookingCombinationFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addFieldCombination(addBookingCombinationFieldVM : OM.AddBookingCombinationFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.BookingConfiguration> {
  
    return CommonServices.defaultPost<OM.BookingConfiguration>(baseUrl + 'api/BookingConfiguration/AddFieldCombination', addBookingCombinationFieldVM, { }, showSpinner, responseType)
  }
}
export let BookingConfigurationClient = new _BookingConfigurationClient();

class _RegistrationConfigurationClient {

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  



  

  getAllDefaultPaged(pagedRequestVM: OM.PagedRequestVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfRegistrationConfiguration> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfRegistrationConfiguration>(baseUrl + 'api/RegistrationConfiguration/GetAllDefaultPaged', paramsObject, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

    

    

    

    


  

  

  
  
  
  




  

  getByCompanyPaged(pagedRequestVM: OM.PagedRequestWithIdentifierVM, router: Router | null, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.PagedResponseOfRegistrationConfigurationVM> {
  
    var paramsObject: any = getPagedRequestParamsObject(pagedRequestVM);
    if(router){
      pushHistoryState(pagedRequestVM, router);
    }
        return CommonServices.defaultGet<OM.PagedResponseOfRegistrationConfigurationVM>(baseUrl + 'api/RegistrationConfiguration/GetByCompanyPaged', paramsObject, showSpinner, responseType)
  }

  

  

  


  

  
  
  
  

  

  getAllDefaultAsList(showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.TextIdentifier[]> {
  
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/RegistrationConfiguration/GetAllDefaultAsList', {  }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  delete(identifier : string, showSpinner = true, responseType: ResponseType = 'json') : Promise<void> {
  
    return CommonServices.defaultGet<void>(baseUrl + 'api/RegistrationConfiguration/Delete', { identifier }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addDefaultBaseField(addDefaultBaseFieldVM : OM.AddDefaultBaseFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.RegistrationConfiguration> {
  
    return CommonServices.defaultPost<OM.RegistrationConfiguration>(baseUrl + 'api/RegistrationConfiguration/AddDefaultBaseField', addDefaultBaseFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addBaseField(addBaseFieldVM : OM.AddBaseFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.RegistrationConfiguration> {
  
    return CommonServices.defaultPost<OM.RegistrationConfiguration>(baseUrl + 'api/RegistrationConfiguration/AddBaseField', addBaseFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addDefaultFieldCombination(addDefaultCombinationFieldVM : OM.AddDefaultCombinationFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.RegistrationConfiguration> {
  
    return CommonServices.defaultPost<OM.RegistrationConfiguration>(baseUrl + 'api/RegistrationConfiguration/AddDefaultFieldCombination', addDefaultCombinationFieldVM, { }, showSpinner, responseType)
  }

  

  

  

    

    

    

    


  

  

  
  
  
  

  

  addFieldCombination(addCombinationFieldVM : OM.AddCombinationFieldVM, showSpinner = true, responseType: ResponseType = 'json') : Promise<OM.RegistrationConfiguration> {
  
    return CommonServices.defaultPost<OM.RegistrationConfiguration>(baseUrl + 'api/RegistrationConfiguration/AddFieldCombination', addCombinationFieldVM, { }, showSpinner, responseType)
  }
}
export let RegistrationConfigurationClient = new _RegistrationConfigurationClient();

interface FileParameter {
    data: any;
    fileName: string;
}

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function pushHistoryState(
  pagedRequestVM: OM.PagedRequestVM | OM.PagedRequestWithIdentifierVM,
  router: Router
) {
  // Ottenere l'URL corrente
  const route = router.currentRoute.value
  const query = { ...route.query }

  delete query['paging.currentPage']
  delete query['paging.itemsPerPage']
  delete query['paging.skip']
  delete query['paging.take']
  delete query['sortBy.propertyName']
  delete query['sortBy.ascending']
  delete query['sortBy.ascending']

  if (typeof pagedRequestVM == typeof OM.PagedRequestWithIdentifierVM) delete query['identifier']

  Object.keys(query)
    .filter((x) => x.startsWith('filter['))
    .forEach((key) => {
      delete query[key]
    })

  if (pagedRequestVM.paging != null) {
    query['paging.currentPage'] =
      pagedRequestVM.paging.currentPage != null ? pagedRequestVM.paging.currentPage.toString() : ''
    query['paging.itemsPerPage'] =
      pagedRequestVM.paging.itemsPerPage != null
        ? pagedRequestVM.paging.itemsPerPage.toString()
        : ''
    query['paging.skip'] =
      pagedRequestVM.paging.skip != null ? pagedRequestVM.paging.skip.toString() : ''
    query['paging.take'] =
      pagedRequestVM.paging.take != null ? pagedRequestVM.paging.take.toString() : ''
  }

  if (pagedRequestVM.sortBy != null) {
    query['sortBy.propertyName'] = pagedRequestVM.sortBy.propertyName.toString()
    query['sortBy.ascending'] = pagedRequestVM.sortBy.ascending.toString()
  }

  if ((<OM.PagedRequestWithIdentifierVM>pagedRequestVM).identifier)
    query['identifier'] = (<OM.PagedRequestWithIdentifierVM>pagedRequestVM).identifier.toString()

  Object.entries(pagedRequestVM.filter).forEach(([key, values]) => {
    values.forEach((value, index) => {
      if (value) {
        query[`filter[${key}][${index}]`] = value
        // query[`filter_${key.replace('.', '_')}`] = value;
      }
    })
  })

  router
    .push({
      path: route.path,
      query: {
        ...query
      }
    })
    .then((err) => {
      // console.error(err);
    })
}

function getPagedRequestParamsObject(
  pagedRequestVM: OM.PagedRequestVM | OM.PagedRequestWithIdentifierVM
) {
  const paramsObject: any = {}

  if (pagedRequestVM.filter && Object.keys(pagedRequestVM.filter).length > 0) {
    Object.entries(pagedRequestVM.filter).forEach(([key, values]) => {
      values.forEach((value, index) => {
        if (value) {
          paramsObject[`filter[${key}][${index}]`] = value
          // query[`filter_${key.replace('.', '_')}`] = value;
        }
      })
    })
  }

  if ((<OM.PagedRequestWithIdentifierVM>pagedRequestVM).identifier)
    paramsObject.identifier = (<OM.PagedRequestWithIdentifierVM>(
      pagedRequestVM
    )).identifier.toString()

  if (pagedRequestVM.paging) {
    paramsObject['paging.currentPage'] = pagedRequestVM.paging.currentPage
    paramsObject['paging.itemsPerPage'] = pagedRequestVM.paging.itemsPerPage
    paramsObject['paging.skip'] = pagedRequestVM.paging.skip
    paramsObject['paging.take'] = pagedRequestVM.paging.take
  }

  if (pagedRequestVM.sortBy) {
    paramsObject['sortBy.propertyName'] = pagedRequestVM.sortBy.propertyName
    paramsObject['sortBy.ascending'] = pagedRequestVM.sortBy.ascending
  }

  return paramsObject
}